<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Payroll NAT Pay</h1>
            @if(!isReadOnly){
            <div class="action">
                <nz-upload
                    [nzShowUploadList]="false" [nzCustomRequest]="customRequest" [nzAccept]="'.csv'">
                    <button nz-button class="primary-btn">
                        <i class="fa fa-upload onemore" aria-hidden="true"></i>
                        Upload NAT File
                    </button>
                </nz-upload>
            </div>
            }
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="table-style">
                    <ppl-list-table [pageConfig]="programName" [sharedDataKey]="sharedDataKey" (rowDetailEvent)="rowClicked($event)" [loadPage]="true" [from]="'natpaylist'"
                        [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
                        [jsonList]="'list_payroll_nat_pay'" rowDataAccessibilityKey="fileName" 
                        [enableActions]="true" [actionButtons]="actionButtons" (gridAction)="onAction($event)"/>
                </div>
            </div>
        </div>
    </div>

</ng-container>


<div class="filter-panel">
    <ng-template #natpayFilesDetails let-cancel="cancel">
        <ppl-payroll-nat-pay-detail [selectedRow]="selectedRow"></ppl-payroll-nat-pay-detail>
    </ng-template>
</div>